import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { VERSION } from 'app/app.constants';
import { LANGUAGES } from 'app/config/language.constants';
import { Account } from 'app/core/auth/account.model';
import { AccountService } from 'app/core/auth/account.service';
// import { ProfileService } from 'app/layouts/profiles/profile.service';
import { EntityNavbarItems } from 'app/entities/entity-navbar-items';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { HttpResponse } from '@angular/common/http';
import { ThemeService } from 'app/core/util/theme.service';


@Component({
  selector: 'cbic-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  inProduction?: boolean;
  isNavbarCollapsed = true;
  languages = LANGUAGES;
  openAPIEnabled?: boolean;
  version = '';
  account: Account | null = null;
  entitiesNavbarItems: any[] = [];
  currentLanguage: any;
  mediaLinkList?: ICbicContentMst[];
  citizensCornerList?: ICbicContentMst[];
  color: any;
  fontSize = 16;
  serachText:any;

  constructor(
    private theme: ThemeService,
    private translateService: TranslateService,
    private sessionStorageService: SessionStorageService,
    private accountService: AccountService,
    // private profileService: ProfileService,
    private router: Router,
    private contentMstService: CbicContentMstService,
    private changeLnService: ChangeLanguageService
  ) {
    const usedLanguage = this.changeLnService.getLanguage();

    if (usedLanguage === "en") {
      this.currentLanguage = "हिन्दी";
    } else {
      this.currentLanguage = "English";
    }

    if (VERSION) {
      this.version = VERSION.toLowerCase().startsWith('v') ? VERSION : `v${VERSION}`;
    }
    this.theme.color.subscribe(clr => this.color = clr);
    this.color = this.theme.getColor();
  }

  ngOnInit(): void {
    this.entitiesNavbarItems = EntityNavbarItems;
    // this.profileService.getProfileInfo().subscribe(profileInfo => {
    //   this.inProduction = profileInfo.inProduction;
    //   this.openAPIEnabled = profileInfo.openAPIEnabled;
    // });

    this.accountService.getAuthenticationState().subscribe(account => {
      this.account = account;
    });

    this.getMediaLinks();
    this.getCitizenSCorner();
  }


  searchResult(serachText: any){
    // this.router.navigate(['/api/search/data-solr']);
    // alert(serachText);
  
        this.router.navigate(['/entities/search', serachText]);
      
    }
    


  getMediaLinks(): void {
    this.contentMstService.getContentData('MediaLinks').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          this.mediaLinkList = res.body;
        }
      }
    )
  }

  getCitizenSCorner(): void {
    this.contentMstService.getContentData('citizens-corner').subscribe(
      (res: HttpResponse<ICbicContentMst[]>) => {
        if (res.body) {
          this.citizensCornerList = res.body;
        }
      }
    )
  }

  changeLanguage(): void {
    let langauageKey;
    if (this.currentLanguage === this.changeLnService.keylanguageMap.hi) {
      langauageKey = "hi";
    } else {
      langauageKey = "en";
    }
    this.changeLnService.changeln(langauageKey);
    if (langauageKey === "hi") {
      this.currentLanguage = this.changeLnService.keylanguageMap.en;
    } else {
      this.currentLanguage = this.changeLnService.keylanguageMap.hi;
    }

  }

  

  collapseNavbar(): void {
    this.isNavbarCollapsed = true;
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  logout(): void {
    this.collapseNavbar();
    // this.loginService.logout();
    this.router.navigate(['']);
  }

  toggleNavbar(): void {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  changeColor(colr: any): void {
    this.theme.changeTheme(colr);
  }

  changeFont(font: any) {
    window.location.reload();
  }


  IncreaseFontSize(operator: any) {
    operator === '+' ? this.fontSize++ : this.fontSize--;
    document.body.style.fontSize = `${this.fontSize}px`;
  }

  DecreaseFontSize(operator: any) {
    operator === '+' ? this.fontSize++ : this.fontSize--;
    document.body.style.fontSize = `${this.fontSize}px`;
  }


  
  
}
